import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Modal, StatusBadge, EmptyState, formatDate } from "@/components/pcp";
import { Plus, Warning, Pencil } from "@phosphor-icons/react";
import { toast } from "sonner";

const empty = { os_id: "", item_id: "", tipo: "Material com defeito", descricao: "", responsavel: "", prazo: "", status: "Aberta", acoes: "" };
const TIPOS = ["Material com defeito", "Acidente", "Paralisação por chuva", "Embargo", "Retrabalho", "Falta de material", "Outros"];

export default function NaoConformidades() {
  const [items, setItems] = useState([]);
  const [ordens, setOrdens] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = async () => {
    const [{ data: nc }, { data: os }] = await Promise.all([api.get("/nao_conformidades"), api.get("/ordens")]);
    setItems(nc); setOrdens(os);
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      const payload = { ...form, os_id: form.os_id || null, item_id: form.item_id || null };
      if (editId) await api.put(`/nao_conformidades/${editId}`, payload);
      else await api.post("/nao_conformidades", payload);
      toast.success("NC salva"); setModal(false); setForm(empty); setEditId(null); load();
    } catch { toast.error("Erro ao salvar"); }
  };

  return (
    <>
      <PageHeader
        testid="page-nc"
        title="Não Conformidades"
        subtitle={`${items.length} registros`}
        actions={<button className="btn btn-primary" onClick={() => { setForm(empty); setEditId(null); setModal(true); }} data-testid="btn-new-nc"><Plus size={16} weight="bold" /> Nova NC</button>}
      />
      <div className="page-body">
        {items.length === 0 ? <EmptyState title="Nenhuma NC registrada" description="Registre problemas, retrabalhos e paralisações para acompanhamento." /> : (
          <div className="pcp-card" style={{ overflowX: "auto" }}>
            <table className="pcp-table">
              <thead><tr><th>Data</th><th>OS</th><th>Tipo</th><th>Descrição</th><th>Responsável</th><th>Prazo</th><th>Status</th><th></th></tr></thead>
              <tbody>
                {items.map((nc) => {
                  const os = ordens.find((o) => o.id === nc.os_id);
                  return (
                    <tr key={nc.id}>
                      <td className="font-mono text-xs">{new Date(nc.created_at).toLocaleDateString("pt-BR")}</td>
                      <td className="font-mono">{os?.numero || "—"}</td>
                      <td><span className="chip">{nc.tipo}</span></td>
                      <td style={{ maxWidth: 320, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{nc.descricao}</td>
                      <td>{nc.responsavel || "—"}</td>
                      <td className="font-mono">{formatDate(nc.prazo)}</td>
                      <td><StatusBadge status={nc.status} /></td>
                      <td><button className="btn btn-ghost btn-sm" onClick={() => { setForm(nc); setEditId(nc.id); setModal(true); }}><Pencil size={14} weight="bold" /></button></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <Modal open={modal} onClose={() => setModal(false)} title={editId ? "Editar NC" : "Nova Não Conformidade"} size="lg">
        <div style={{ display: "grid", gap: 12 }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <F label="OS"><select className="select" value={form.os_id || ""} onChange={(e) => setForm({ ...form, os_id: e.target.value })}><option value="">—</option>{ordens.map((o) => <option key={o.id} value={o.id}>{o.numero}</option>)}</select></F>
            <F label="Tipo"><select className="select" value={form.tipo} onChange={(e) => setForm({ ...form, tipo: e.target.value })}>{TIPOS.map((t) => <option key={t}>{t}</option>)}</select></F>
          </div>
          <F label="Descrição *"><textarea className="textarea" rows={3} value={form.descricao} onChange={(e) => setForm({ ...form, descricao: e.target.value })} data-testid="nc-descricao" /></F>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
            <F label="Responsável"><input className="input" value={form.responsavel} onChange={(e) => setForm({ ...form, responsavel: e.target.value })} /></F>
            <F label="Prazo"><input type="date" className="input" value={form.prazo || ""} onChange={(e) => setForm({ ...form, prazo: e.target.value })} /></F>
            <F label="Status"><select className="select" value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}><option value="Aberta">Aberta</option><option value="Em tratamento">Em tratamento</option><option value="Encerrada">Encerrada</option></select></F>
          </div>
          <F label="Ações corretivas"><textarea className="textarea" rows={2} value={form.acoes} onChange={(e) => setForm({ ...form, acoes: e.target.value })} /></F>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 24 }}>
          <button className="btn btn-outline" onClick={() => setModal(false)}>Cancelar</button>
          <button className="btn btn-primary" onClick={save} data-testid="btn-save-nc">Salvar</button>
        </div>
      </Modal>
    </>
  );
}
function F({ label, children }) { return <div><div className="label">{label}</div>{children}</div>; }
